export default __webpack_public_path__ + "static/media/1.5936a1d6.png";